import CookieLegals from './CookieLegals'

export default CookieLegals
